import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { Text } from '../../../../components/Typography/Typography';
import EvaluationRow from './EvaluationRow';
import { updateGroup } from '../../../../store/evaluation/slice';
import { EvaluationGroup } from '../../../../store/evaluation/types';
import styles from '../EvaluationsPage.module.scss';

const EvaluationsTable: React.FC = () => {
  const dispatch = useDispatch();
  const [openModalIndex, setOpenModalIndex] = useState<number | null>(null);
  const { groups } = useSelector((state: RootState) => state.evaluation);

  const handleNavigate = (currentIndex: number, direction: 'prev' | 'next') => {
    const newIndex = direction === 'prev' ? currentIndex - 1 : currentIndex + 1;
    if (newIndex >= 0 && newIndex < groups.length) {
      setOpenModalIndex(newIndex);
      const element = document.querySelector(`[data-row-index="${newIndex}"]`);
      element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };

  const handleGroupUpdate = (updatedGroup: EvaluationGroup) => {
    dispatch(updateGroup(updatedGroup));
  };

  return (
    <div className={styles.table}>
      <div className={styles.header}>
        <Text weight="medium" color="neutral-600">
          Trigger
        </Text>
        <Text weight="medium" color="neutral-600">
          Question
        </Text>
        <Text weight="medium" color="neutral-600">
          Score
        </Text>
        <Text weight="medium" color="neutral-600">
          Actions
        </Text>
      </div>
      {groups.map((group, index) => (
        <div key={group.trace_id} data-row-index={index}>
          <EvaluationRow
            group={group}
            isModalOpen={openModalIndex === index}
            onModalOpen={() => setOpenModalIndex(index)}
            onModalClose={() => setOpenModalIndex(null)}
            onNavigate={(direction) => handleNavigate(index, direction)}
            onGroupUpdate={handleGroupUpdate}
          />
        </div>
      ))}
      {groups.length === 0 && (
        <div className={styles.noResults}>
          <Text color="neutral-600" align="center">
            No evaluations found
          </Text>
        </div>
      )}
    </div>
  );
};

export default EvaluationsTable;
